<template>
  <div>
    <!-- 提现加速卡 -->
    <div
      class="card-detail type_speed"
      v-if="type==='WITHDRAW_QUEUE_CARD'"
    >
      <p>提现加速卡</p>
      <span>插队优先审核</span>
    </div>

    <div
      class="card-detail type_funds"
      v-if="type==='DEDICATED_FUNDS'"
    >
      <p>专属资金</p>
      <span>通过率提升5倍</span>
    </div>

    <div
      class="card-detail type_raise"
      v-if="type==='RAISE_1000'"
    >
      <p>1000元 <br>提额</p>
      <span>仅限今日有效</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

 .card-detail {
    width: 628px;
    height: 860px;
    position: absolute;
    background: url("../act-four-detail/images/pop_001@2x.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    
    p,span {
      color: #dd752d;
    }
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #C2601C;
      line-height: 40px;
      margin-top: 10px;
    }
    &.type_speed {
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 56px;
        color: #DD752D;
        line-height: 80px;
        width: 1em;
        display: block;
        margin-top: 40px;
      }
    }
    &.type_funds {
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 56px;
        color: #DD752D;
        line-height: 80px;
        width: 1em;
        display: block;
        margin-top: 70px;
        margin-bottom:30px;
      }
    }
    &.type_raise {
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 56px;
        color: #DD752D;
        line-height: 80px;
        display: block;
        margin-top: 180px;
        margin-bottom:120px;
        text-align: center;
      }
    }
  }
</style>